import { render, staticRenderFns } from "./CorsAllowedHeaders.vue?vue&type=template&id=0667f1e3&"
import script from "./CorsAllowedHeaders.vue?vue&type=script&lang=js&"
export * from "./CorsAllowedHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports